// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/Country.yaml
// Generated: 2026-03-27T07:15:39.702Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateCountry, UpdateCountry, Country } from '@/types/core/Country';

/**
 * Country Service
 * CRUD operations for Country via the ABP API.
 */
export const countryService = new EntityService<Country, CreateCountry, UpdateCountry>(
  '/api/core/country',
  'Country',
);
